import React, {Component} from "react";
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import apiClient from "api/client";
import connect from "react-redux/es/connect/connect";
import {withNamespaces} from "react-i18next";

class DropDownTvGuide extends Component {

    constructor(props) {
        super(props);

        this.handleSelect = this.handleSelect.bind(this);
        this.state = {
            loading: false,
            guide: []
        };

        this.isMountedFlag = false;
        this.requestSource = null;
    }

    componentDidMount() {
        this.isMountedFlag = true;
        this.loadData();
    }

    componentWillUnmount() {
        this.isMountedFlag = false;
        this.cancelPendingRequest();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        console.log("componentDidUpdate------>");
        console.log(prevProps);
        console.log(this.props.guideChannelSelected);
        if (this.props.guideChannelSelected !== prevProps.guideChannelSelected) {
            if (this.props.guideChannelSelected) {
                this.loadData()
                // this.handleSelect('reload')
            }
        }
    }

    handleSelect(value) {
        this.props.handlerFromParent(value);
    }

    safeSetState(nextState) {
        if (this.isMountedFlag) {
            this.setState(nextState);
        }
    }

    cancelPendingRequest() {
        if (this.requestSource) {
            this.requestSource.cancel("DropDownTvGuide request cancelled.");
            this.requestSource = null;
        }
    }

    clearRequestSource(requestSource) {
        if (this.requestSource === requestSource) {
            this.requestSource = null;
        }
    }

    loadData() {
        const url = process.env.REACT_APP_API_URL + "/channels/guide";
        const requestSource = apiClient.CancelToken.source();

        this.cancelPendingRequest();
        this.requestSource = requestSource;
        this.safeSetState({loading: true});

        apiClient.get(url, {
            cancelToken: requestSource.token
        })
            .then(res => {
                if (this.requestSource !== requestSource) {
                    return;
                }

                this.clearRequestSource(requestSource);
                this.safeSetState({
                    guide: res.data,
                    loading: false
                });
            })
            .catch(error => {
                if (apiClient.isCancel(error)) {
                    return;
                }

                this.clearRequestSource(requestSource);
                this.safeSetState({loading: false});
                console.log(error);
            });
    }

    render() {
        return (
            <div>
                {this.state && this.state.guide &&
                    <Select
                        placeholder="Channel Select"
                        name="guideSelect"
                        autoFocus={false}
                        multi={false}
                        isSearchable={true}
                        disabled={this.props.disabled}
                        value={this.props.guideChannelSelected}
                        options={this.state.guide}
                        onChange={value => this.handleSelect(value)}

                    />
                }
            </div>
        );
    }

}

function mapStateToProps(state) {

    const {authentication} = state;
    const {user} = authentication;
    return {
        user
    };
}

const connectedDropDownTvGuide = connect(mapStateToProps)(DropDownTvGuide);
const connectedDropDownTvGuideTrans = withNamespaces('common')(connectedDropDownTvGuide);
export {connectedDropDownTvGuideTrans as DropDownTvGuide};
